module.exports = __webpack_public_path__ + "public/img/jianyue.1fa0a89d.jpg";